import { API, doPost, doGet } from "@/api/api.js"

export default {
    data: function() {
        return {
            handleMulti: false, //false代表单选操作，true代表多选操作
            scheduleForm: {
                productId: "",
                productCode: "",
                logType: 0,
                salerId: "",
                memo: ""
            },
            statusLayer: false,
        }
    },
    methods: {
        salerChange: function(e) {
            localStorage.setItem("CURRENT_SALER_ID", e);
        },
        updateStatusOpen: async function (productId, status, multi) {
            if (multi && this.selectRows.length == 0) {
                this.$message.error("未选择任何数据");
                return;
            }
            this.handleMulti = multi;
            if (productId) {
                this.scheduleForm.productId = productId;
            }
            this.scheduleForm.logType = status;
            this.scheduleForm.memo = "";
            this.statusLayer = true;
            if (productId) {
                this.saleAdmins = await doGet(API.SALE_ADMINS, {
                    productId: this.scheduleForm.productId,
                    productStatus: this.scheduleForm.logType
                });
            }
            else {
                this.saleAdmins = this.admins;
            }
            if (!this.application) {
                if (localStorage.getItem("CURRENT_SALER_ID")) {
                    if (status < 6) {
                        this.scheduleForm.salerId = localStorage.getItem("CURRENT_SALER_ID");
                    }
                    else {
                        this.scheduleForm.salerId = this.saleAdmins[0].adminId;
                    }
                }
                else {
                    this.scheduleForm.salerId = this.saleAdmins[0].adminId;
                }
            }
        },
        updateStatusClose: function () {
            this.scheduleForm.productId = "";
            this.scheduleForm.productCode = "";
            this.scheduleForm.logType = 0;
            this.scheduleForm.salerId = "";
            this.scheduleForm.memo = "";
            this.scheduleForm.productPay = "";
            this.statusLayer = false;
        },
        updateStatusConfirm: async function () {
            if ((this.manager || this.distribute) && !this.scheduleForm.salerId) {
                this.showResult({
                    errorCode: 100,
                    errorMessage: "尚未选择代卖人"
                });
                return;
            }
            if (this.scheduleForm.logType == 6 && (this.scheduleForm.productPay === null || this.scheduleForm.productPay === undefined || this.scheduleForm.productPay === '')) {
                this.showResult({
                    errorCode: 100,
                    errorMessage: "请选择结算状态"
                });
                return;
            }
            if (this.application) { //申请权限，去掉代卖人，以防出现混乱数据
                this.scheduleForm.salerId = "";
            }
            if (this.handleMulti) {
                for (let i = 0; i < this.selectRows.length; i++) {
                    this.scheduleForm.productId = this.selectRows[i].productId;
                    let resultObj = await doPost(API.PRODUCT.SCHEDULE, this.scheduleForm);
                    if (resultObj.errorCode == 0) {
                        this.$message.success(resultObj.errorMessage);
                    }
                    else {
                        this.$message.error(resultObj.errorMessage);
                    }
                }
                this.isHandle = false;
                this.loadData();
            }
            else {
                let resultObj = await doPost(API.PRODUCT.SCHEDULE, this.scheduleForm);
                this.showResult(resultObj);
            }
            this.updateStatusClose();
        },
    }
}